/* ============================================================
   One colour, two jobs.

   A verdict badge paints itself a 12% wash of its tone and then puts
   the label on top in that same tone. As a wash the colour is right —
   it is the tone the palette specifies. As a word it is 3.3–3.5:1,
   because the tone colours were chosen to be seen rather than read.

   So the tone travels as it always did and the call site names which
   job it is doing. `readable()` maps a semantic tone to its reading
   sibling; anything it does not recognise comes back untouched, so a
   raw hex or a per-tool accent passes through and shows up in the
   contrast sweep rather than being silently rewritten into a colour
   nobody chose.

   The sweep across every route, brand and colour scheme is what found
   this and is what keeps it fixed.
   ============================================================ */

const TONE = /^\s*var\(\s*--ca-(positive|warning|danger|info)\s*\)\s*$/;

/**
 * @param {string} tone a semantic tone, e.g. 'var(--ca-warning)'
 * @returns {string} the reading colour for that tone, or the input
 */
export function readable(tone) {
  if (typeof tone !== 'string') return tone;
  const m = tone.match(TONE);
  return m ? `var(--ca-${m[1]}-text)` : tone;
}
